import React from "react";
import Link from "next/link";

const SearchCommunityHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Searching for a Community</h2>
            <p>
                We're here to help you find the perfect community! Here's how to get
                started:
            </p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Search Tips</h3>
                    <ul className="list-disc pl-5 text-gray-800 mt-1 space-y-2">
                        <li>Use the search bar to find communities by location or name</li>
                        <li>View communities information, photos, floor plans</li>
                        <li>Save your favorites to compare later</li>
                    </ul>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Need Advice?</h3>
                    <p className="text-gray-8000 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        and an advisor will contact you.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Call Us</h3>
                    <p className="text-gray-8000 mt-1">
                        Speak with an advisor at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        <br />
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our team is available during business hours to assist you.
            </p>
        </div>
    );
};

export default SearchCommunityHelp;
